import { Boolean, Record, Static, Function, Union, Null } from 'runtypes'
import { connect } from 'react-redux'
import moment from 'moment'
import { useState } from 'react'

import styles from './SingleComment.module.scss'
import LikeCommentButton from '../LikeCommentButton/LikeCommentButton'
import DislikeCommentButton from '../DislikeCommentButton/DislikeCommentButton'
import CommentReplyButton from '../CommentReplyButton/CommentReplyButton'
import { Comment } from '../../../../types/comment'
import { CommentsApi } from '../../../../api/comments'
import { Post } from '../../../../types'
import AddComment from '../AddComment/AddComment'
import { actions } from '../../../../store'

const SingleCommentProps = Record({
  post: Post,
  comment: Comment,
  isChildComment: Boolean,
  isUserLoggedIn: Union(Boolean, Null),
  addCommentHandler: Union(Function, Null),
  commentLiked: Union(Function, Null),
  commentDisliked: Union(Function, Null),
  displaySignupForm: Function,
})

type SingleCommentProps = Static<typeof SingleCommentProps>

const SingleComment = ({
  post,
  comment,
  isChildComment,
  isUserLoggedIn,
  addCommentHandler,
  commentLiked,
  commentDisliked,
  displaySignupForm,
}: SingleCommentProps) => {
  const [displayReplyField, setDisplayReplyField] = useState(false)
  const [commentReported, setCommentReported] = useState(false)

  const likedHandler = async () => {
    if (isUserLoggedIn) {
      await CommentsApi.like(post.slug, comment.id, true)
      commentLiked(comment.id)
    } else {
      displaySignupForm()
    }
  }

  const dislikeHandler = async () => {
    if (isUserLoggedIn) {
      await CommentsApi.dislike(post.slug, comment.id, true)
      commentDisliked(comment.id)
    } else {
      displaySignupForm()
    }
  }

  const reportCommentHandler = async () => {
    if (isUserLoggedIn) {
      CommentsApi.report(comment.id, post.slug)
      setCommentReported(true)
    } else {
      displaySignupForm()
    }
  }

  const toggleReplyCommentInput = () => {
    setDisplayReplyField(!displayReplyField)
  }

  return (
    <div
      className={`${styles.singleComment} ${
        isChildComment ? 'ml-10' : ''
      } mt-4 w-full`}
    >
      <div className="mt-4 border border-grayText rounded-xl py-1 px-6">
        <div className="flex mb-2">
          <p className="w-3/6">
            <span className={`${styles.username} tracking-tighter`}>
              {comment.author}
            </span>
            <span>&nbsp;</span>
            <span className={`${styles.createdAt}`}>
              {`${moment(comment.created_at).format('DD.MM.YYYY HH:mm')}h`}
            </span>
          </p>
          {!commentReported ? (
            <p
              className={`${styles.reportComment} w-3/6 text-right cursor-pointer `}
              onClick={reportCommentHandler}
            >
              Prijavi komentar
            </p>
          ) : (
            <p
              className={`${styles.reportComment} w-3/6 text-right cursor-pointer `}
            >
              <span>Hvala vam što se prijavili komentar.</span>
              <br /> <span>Naši zaposleni će ga proveriti.</span>
            </p>
          )}
        </div>
        <p className={styles.comment}>{comment.comment}</p>
      </div>
      <div className="flex px-8">
        <LikeCommentButton
          likedHandler={likedHandler}
          isLiked={comment.like_dislike ? !!comment.like_dislike.likes : false}
          isDisliked={
            comment.like_dislike ? !!comment.like_dislike.dislikes : false
          }
          numberOfLikes={
            comment.parent_comment_id
              ? comment.total_rel_likes_count
              : comment.total_likes
          }
        />
        <DislikeCommentButton
          dislikeHandler={dislikeHandler}
          isLiked={comment.like_dislike ? !!comment.like_dislike.likes : false}
          isDisliked={
            comment.like_dislike ? !!comment.like_dislike.dislikes : false
          }
          numberOfDislikes={
            comment.parent_comment_id
              ? comment.total_rel_dislikes_count
              : comment.total_dislike
          }
        />
        {!isChildComment ? (
          <CommentReplyButton toggle={toggleReplyCommentInput} />
        ) : null}
      </div>
      <div>
        {displayReplyField ? (
          <div className="px-5 min-h-10">
            <AddComment
              addCommentHandler={(comment, parentID, username, email) => {
                setDisplayReplyField(false)
                addCommentHandler(comment, parentID, username, email)
              }}
              parentID={comment.id}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    openedPost: state.openedPost,
    isUserLoggedIn: state.isUserLoggedIn,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    commentLiked: (commentId) =>
      dispatch({
        type: actions.COMMENT_LIKED,
        payload: {
          commentId,
        },
      }),
    commentDisliked: (commentId) =>
      dispatch({
        type: actions.COMMENT_DISLIKED,
        payload: {
          commentId,
        },
      }),
    displaySignupForm: () =>
      dispatch({
        type: 'SHOW_SIGNUP_MODAL',
      }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleComment)
